import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** DRAFT → SUBMITTED。body 僅 updatedAt。 */
export async function submitStockAdjustment(id, payload = {}) {
  const { data: raw } = await request.post(
    `/ims/stock-adjustment/${id}/submit`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
